module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h2', {
    staticClass: "fmh"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Cover#cover",
      "id": "rcover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Titlepage#tit",
      "id": "rtit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Dedication#_idParaDest-1",
      "id": "r_idParaDest-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Epigraph#_idParaDest-2",
      "id": "r_idParaDest-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('a', {
    attrs: {
      "hidden": "hidden",
      "href": "#/text/nav"
    }
  }, [_c('span', {
    staticClass: "hide1"
  }, [_vm._v("Contents")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062674623_Part_1#_idParaDest-3",
      "id": "r_idParaDest-3"
    }
  }, [_vm._v("Part One")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_1#_idParaDest-5",
      "id": "r_idParaDest-5"
    }
  }, [_vm._v("Before")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_2#_idParaDest-6",
      "id": "r_idParaDest-6"
    }
  }, [_vm._v("Now")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_3#_idParaDest-7",
      "id": "r_idParaDest-7"
    }
  }, [_vm._v("Then")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_4#_idParaDest-8",
      "id": "r_idParaDest-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Now")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_5#_idParaDest-9",
      "id": "r_idParaDest-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Before")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_6#_idParaDest-10",
      "id": "r_idParaDest-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Then")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_7#_idParaDest-11",
      "id": "r_idParaDest-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Before")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_8#_idParaDest-12",
      "id": "r_idParaDest-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Now")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_9#_idParaDest-13",
      "id": "r_idParaDest-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Then")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_10#_idParaDest-14",
      "id": "r_idParaDest-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Now")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_11#_idParaDest-15",
      "id": "r_idParaDest-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Then")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_12#_idParaDest-16",
      "id": "r_idParaDest-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Before")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_13#_idParaDest-17",
      "id": "r_idParaDest-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Now")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_14#_idParaDest-18",
      "id": "r_idParaDest-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Then")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_15#_idParaDest-19",
      "id": "r_idParaDest-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Now")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_16#_idParaDest-20",
      "id": "r_idParaDest-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Before ")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_17#_idParaDest-21",
      "id": "r_idParaDest-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Then")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.5em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Part_2#_idParaDest-22",
      "id": "r_idParaDest-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_18#_idParaDest-24",
      "id": "r_idParaDest-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Then")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_19#_idParaDest-25",
      "id": "r_idParaDest-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Now")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_20#_idParaDest-26",
      "id": "r_idParaDest-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Then ")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_21#_idParaDest-27",
      "id": "r_idParaDest-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Before")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_22#_idParaDest-28",
      "id": "r_idParaDest-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Then")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_23#_idParaDest-29",
      "id": "r_idParaDest-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Now")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_24#_idParaDest-30",
      "id": "r_idParaDest-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Then")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_25#_idParaDest-31",
      "id": "r_idParaDest-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Before")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_26#_idParaDest-32",
      "id": "r_idParaDest-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Now")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_27#_idParaDest-33",
      "id": "r_idParaDest-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Then")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_28#_idParaDest-34",
      "id": "r_idParaDest-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Now")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_29#_idParaDest-35",
      "id": "r_idParaDest-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Before")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_30#_idParaDest-36",
      "id": "r_idParaDest-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Then")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_31#_idParaDest-37",
      "id": "r_idParaDest-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Now")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_32#_idParaDest-38",
      "id": "r_idParaDest-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Then")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_33#_idParaDest-39",
      "id": "r_idParaDest-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Before ")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_34#_idParaDest-40",
      "id": "r_idParaDest-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Now ")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_35#_idParaDest-41",
      "id": "r_idParaDest-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Then")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "padding-left": "1em"
    },
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_36#_idParaDest-42",
      "id": "r_idParaDest-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Now")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "epub:type": "backmatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Acknowledgments#_idParaDest-43",
      "id": "r_idParaDest-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments ")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "backmatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#_idParaDest-44",
      "id": "r_idParaDest-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "backmatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Also_by#_idParaDest-45",
      "id": "r_idParaDest-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Gurjinder Basran")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "backmatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Credits#_idParaDest-46",
      "id": "r_idParaDest-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Credits")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "backmatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Copyright#_idParaDest-47",
      "id": "r_idParaDest-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "backmatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#_idParaDest-48",
      "id": "r_idParaDest-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])]), _vm._v(" "), _c('div', {
    staticClass: "hide1"
  }, [_c('nav', {
    attrs: {
      "epub:type": "landmarks",
      "hidden": "hidden"
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_vm._v("Guide")]), _vm._v(" "), _c('ol', [_c('li', [_c('span', {
    attrs: {
      "epub:type": "cover",
      "href": "#/text/9780062674623_Cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/text/nav"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/text/9780062674623_Chapter_1"
    }
  }, [_vm._v("Chapter 1")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hide1"
  }, [_c('nav', {
    attrs: {
      "epub:type": "page-list",
      "hidden": "hidden",
      "xmlns:epub": "http://www.idpf.org/2007/ops"
    }
  }, [_c('ol', [_c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Also_by#page_ii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ii")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Titlepage#page_iii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Dedication#page_iv",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iv")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Epigraph#page_v",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("v")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Epigraph#page_vi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("vi")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062674623_Part_1#page_1"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/text/9780062674623_Part_1#page_2"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Part_2#page_133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Part_2#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780062674623_Chapter_20#page_150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64ebf9b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/nav.vue
// module id = 69
// module chunks = 0